import React from 'react';
interface CTAButtonProps {
  text: string;
  className?: string;
  onClick?: () => void;
}
export function CTAButton({
  text,
  className = '',
  onClick
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent) => {
    if (onClick) {
      onClick();
    } else {
      e.preventDefault();
      const element = document.getElementById('oferta');
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      } else {
        window.location.hash = 'oferta';
      }
    }
  };
  return <a href="#oferta" onClick={handleClick} className={`w-full md:w-auto btn-premium py-[20px] px-[36px] rounded-[20px] transition-all duration-300 text-lg md:text-xl flex items-center justify-center gap-3 hover:scale-[1.02] active:scale-95 no-underline whitespace-nowrap ${className}`} data-id="element-89">
      <span className="text-2xl" data-id="element-90">👇</span> {text}
    </a>;
}